import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

/**
 * Copy text to the clipboard, resolving to whether it succeeded.
 *
 * Tries the async Clipboard API first, then falls back to a hidden-textarea
 * `execCommand('copy')` — the async API is unavailable in insecure contexts
 * and blocked inside cross-origin iframes, where the legacy path still works.
 */
export async function copyToClipboard(text) {
	try {
		await navigator.clipboard.writeText(text);
		return true;
	} catch {
		// async clipboard unavailable / blocked — fall through to the legacy path
	}
	try {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		const ok = document.execCommand('copy');
		document.body.removeChild(textarea);
		return ok;
	} catch {
		return false;
	}
}
